import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {
  addDirectory,
  deleteSingleDirectoryData,
  updateSingleDirectoryData,
} from "../../../Redux/Directory/action";
import { useDispatch, useSelector } from "react-redux";

const DirectoryContactDeleteModal = ({ show, onHide, directoryContactID }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    await deleteSingleDirectoryData(dispatch, directoryContactID);
    onHide();
  };
  const handleClose = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Staff</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this staff member?
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{background : "red"}} onClick={handleSubmit}>
            Delete
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DirectoryContactDeleteModal;
